import * as Sentry from '@sentry/vue';
import { Pinia } from 'pinia';
import { App } from 'vue';

import { TwitchStoreState } from './store/types/TwitchStoreState';

interface SentryMetadata {
	channelId: string;
	viewerId: string;
	viewerRole: string | undefined;
}

const stateTransformer = (state: Partial<TwitchStoreState>) => {
	const transformedState = {
		...state,
		broadcaster: {
			...state.broadcaster,
			helixToken: 'I love pizza',
			token: 'I really love pizza',
		},
	};

	return transformedState;
};

const ACTIONS_TO_SKIP = ['authorizationReceived'];
const actionTransformer = (action: string) => {
	if (ACTIONS_TO_SKIP.includes(action)) {
		return null;
	}

	return action;
};

export const addSentryPiniaPlugin = (pinia: Pinia): Pinia =>
	pinia.use(
		Sentry.createSentryPiniaPlugin({
			actionTransformer,
			stateTransformer,
		}),
	);

export const initSentry = (app: App): ReturnType<typeof Sentry.init> =>
	Sentry.init({
		app,
		dsn: import.meta.env.VITE_SENTRY_DSN,
		environment: import.meta.env.MODE,
		tracesSampleRate: 0.05,
		debug: false,
		release: import.meta.env.VITE_APP_VERSION,
		integrations: [Sentry.browserTracingIntegration()],
	});

export const addSentryMetadata = ({
	viewerId,
	channelId,
	viewerRole,
}: SentryMetadata): void => {
	Sentry.setUser({
		id: viewerId,
	});

	Sentry.setTags({
		channelId,
		viewerRole: viewerRole ?? 'viewer',
	});
};
